/**
 * The visible staging marker (ENV-N.4 / ENV-P.4): a fixed strip across the
 * very top of the viewport, above the Nav, in the violet Sandglass uses for
 * the same marker on its own surfaces (`bg-stage`), naming the stage and the
 * release the build is for. Renders nothing on prod and dev, where
 * `__PHAROS_STAGE__` is null (vite.config.ts bakes it from VITE_STAGE at
 * build time; sst.config.ts sets that on staging only).
 *
 * WHY the height is a CSS variable: the Nav is fixed at the top and the
 * sections' anchor offsets are tuned to it. `--stage-banner-h` (index.css) is
 * 0 unless `<html data-stage>` is present, which vite.config.ts writes for
 * the same builds that render this strip; the Nav's `top`, <main>'s top
 * padding, `.section-anchor` and this strip's own height all read it, so the
 * one layout serves every stage and staging's is shifted down by exactly the
 * strip. The wording drops to "STAGING · version" below `sm` so it never
 * wraps inside the fixed height; the version keeps its case.
 * WHY no interaction: it is a label, not a control; pointer events pass
 * through so it never blocks a tap.
 */
export function StageBanner() {
  if (!__PHAROS_STAGE__) return null;
  return (
    <div
      role="status"
      aria-label={`${__PHAROS_STAGE__} environment, release ${__PHAROS_VERSION__}`}
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] flex h-[var(--stage-banner-h)] select-none items-center justify-center bg-stage px-4 font-mono text-[0.7rem] font-semibold uppercase tracking-[0.25em] text-bg-base sm:text-sm sm:tracking-[0.3em]"
    >
      <span className="whitespace-nowrap">
        {__PHAROS_STAGE__}
        <span className="hidden sm:inline"> &mdash; not the shop&rsquo;s inbox</span>
        {" "}&middot;{" "}
        <span className="normal-case">{__PHAROS_VERSION__}</span>
      </span>
    </div>
  );
}
